export enum GradeKey {
  GRADE = 'grade',
  USER_GRADES = 'userGrades',
  GROUP_GRADES = 'groupGrades',
  USER_GROUP_GRADES = 'userGroupGrades',
}
